import { isValid, parse, startOfDay } from 'date-fns';
import spacetime from 'spacetime';

import { DATE_FORMAT_LONG_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';
import { tzMoscow } from '../../../CorePackage/MainModule/constants/timeZone';

export const parseProductSalesFormDate = (value: string | Date | null | undefined): Date | undefined => {
  if (!value) {
    return undefined;
  }
  if (value instanceof Date) {
    return startOfDay(value);
  }

  return startOfDay(parse(value, DATE_FORMAT_LONG_FNS, new Date()));
};

export const isInvalidProductSalesFormDate = (value: string | Date | null | undefined): boolean => {
  const parsed = parseProductSalesFormDate(value);

  return !!value && (!parsed || !isValid(parsed));
};

export const getProductSalesToday = (): Date => {
  const moscowNow = spacetime.now(tzMoscow);

  return startOfDay(new Date(moscowNow.year(), moscowNow.month(), moscowNow.date()));
};
